import { FormattedMessage } from 'dibs-react-intl';

export const copy = {
    save: <FormattedMessage id="checkout.sharedCopy.save" defaultMessage="save" />,
};
